<template>
    <span class="form__required-indicator" v-if="inputData.required">*</span>
</template>
<script>
export default {
    props: ['inputData'],
}
</script>